import React, { useState, useEffect } from "react";

// estilos
import "../../assets/style/componentPrincipal.css";
import "./compras.css";
import "../../assets/style/tablesG.css";

// componentes
import { Buscar } from "../general/buscadorGastos/Buscar";
import { ModalProgress } from "../modals/ModalProgress";
import { TableList } from "./tableList";

import { useBuy } from "../../hooks/useBuy";
import { Link } from "react-router-dom";
import { DateFilters } from "./list/DateFilters";
import { BoxTotals } from "./list/BoxTotals";

export const ComprasLista = () => {
  const [loading, setLoading] = useState(true);
  const { buys, totals, initGetAllBuy } = useBuy();

  const [filters, setFilters] = useState({
    time: "month",
    text: "",
    fecha_desde: new Date(),
    fecha_hasta: new Date(),
    check_emitida: true,
    check_pagada: true,
    check_anulada: false,
    check_abonado: false,
    check_justificado: false,
    origen: "",
    page: 1,
    rows: 10,
  });

  useEffect(() => {
    setLoading(true);
    initGetAllBuy(filters);
    setLoading(false);
  }, [filters, initGetAllBuy]);

  const handleChangeDateDesde = (newValue) => {
    setFilters({
      ...filters,
      fecha_desde: newValue,
    });
  };

  const handleChangeDateHasta = (newValue) => {
    setFilters({
      ...filters,
      fecha_hasta: newValue,
    });
  };

  return (
    <div className="p-container">
      <h1 className="p-title m-2">Gastos</h1>

      <DateFilters
        filters={filters}
        setFilters={setFilters}
        handleChangeDateDesde={handleChangeDateDesde}
        handleChangeDateHasta={handleChangeDateHasta}
      />

      <div className="flex m-2">
        <Buscar filters={filters} setFilters={setFilters} />
      </div>

      {loading && <ModalProgress />}

      <div className="row p-box-filters">
        <div className="col p-box-filters-items">
          <Link to="/gastos/compras" className="selected">
            Lista de gastos
          </Link>
          <Link to="/gastos/pptos">Presupuestos de gastos</Link>
        </div>
      </div>

      <BoxTotals totals={totals} />

      <TableList
        filters={filters}
        setFilters={setFilters}
        list={buys}
        cantidad={totals?.cantidad || 0}
      />
    </div>
  );
};
